__turbopack_context__.v({
  "className": "robotobold_fbe5cf9e-module__ibMV_q__className",
  "variable": "robotobold_fbe5cf9e-module__ibMV_q__variable",
});
